var scope_0 = require('/home/runner/work/mozaic-design-system/mozaic-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8152bed619ee9e7428b1811e6dc895c4.js').default;
var scope_1 = require('/home/runner/work/mozaic-design-system/mozaic-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8d17158fe3d3cce4dbbb226031887037.js').default;
var scope_2 = require('/home/runner/work/mozaic-design-system/mozaic-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    